<template>
  <div class="forget_password_dialog">
    <div class="mobile_code" v-if="step == 1">
      <el-form :model="form" :rules="fogetRules" @submit.native.prevent ref="form">
        <el-form-item prop="mobile">
          <div class="mobile_input" @mouseenter="mobileMove" @mouseleave="mobileOut">
            <el-input v-model="form.mobile" placeholder="请输入手机号" @focus="mobileFocus" @input="mobileInput" @blur.prevent="mobileBlur" :class="isMobileError ? 'mobile_input_error' : ''">
              <template slot="prefix">
                <div class="mobile_icon"></div>
              </template>
              <template slot="suffix">
                <transition name="shanchu">
                  <div class="mobile_delete delete_icon" v-show="showMobileIcon && !mobileErrorMsg" @click="mobileDelete"></div>
                </transition>
              </template>
            </el-input>
            <transition name="shanchu">
              <div v-show="mobileErrorMsg" class="mobile_error_msg">{{ mobileErrorMsg }}</div>
            </transition>
          </div>
        </el-form-item>
        <el-form-item prop="code">
          <div class="code_input" @mouseenter="codeMove" @mouseleave="codeOut">
            <el-input v-model="form.code" placeholder="请输入验证码" @focus="codeFocus" @input="codeInput" @blur="codeBlur" :class="isCodeError ? 'code_input_error' : ''" ref="codeInput">
              <template slot="prefix">
                <div class="code_icon"></div>
              </template>
              <template slot="suffix">
                <transition name="shanchu">
                  <div class="delete_icon code_delete" v-show="showIcon && !codeErrorMsg" @click="codeDelete"></div>
                </transition>
              </template>
            </el-input>
            <button :class="['gain_code',form.mobile.length == 11 && waitTime < 0? 'can_code':'',waitTime > 0 ? 'cant_code':'']" @click="gainCode">{{ waitTime >= 0?  '重新获取('+waitTime + 's)' : "获取验证码" }}</button>
            <div v-show="codeErrorMsg" class="code_error_msg">{{ codeErrorMsg }}</div>
          </div>
        </el-form-item>
        <button :class="['next',canClkNext?'can_next':'']" @click="next">下一步</button>
      </el-form>
    </div>
    <div v-if="step == 2" class="mobile_code password_input">
      <el-form :model="passwordForm" :rules="passwordRules" @submit.native.prevent ref="passwordForm">
        <el-form-item prop="newPassword">
          <div class="mobile_input" @mouseenter="newPasswordMove" @mouseleave="newPasswordOut">
            <el-input v-model="passwordForm.newPassword" placeholder="输入新密码" @focus="newPasswordFocus" @input="newPasswordInput" @blur.prevent="newPasswordBlur" :class="isNewPasswordError ? 'mobile_input_error' : ''">
              <template slot="suffix">
                <transition name="shanchu">
                  <div class="mobile_delete delete_icon" v-show="showNewPasswordIcon&& !errorMessage" @click="newPasswordDelete"></div>
                </transition>
              </template>
            </el-input>
            <transition name="shanchu">
              <div class="errorMessage" v-if="errorMessage">
                密码长度为8-16,需包含数字、字母
              </div>
            </transition>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <div class="mobile_input" @mouseenter="passwordMove" @mouseleave="passwordOut" style="margin-top:16px">
            <el-input v-model="passwordForm.password" placeholder="确认密码" @focus="passwordFocus" @input="passwordInput" @blur.prevent="passwordBlur" :class="isPasswordError ? 'mobile_input_error' : ''">
              <template slot="suffix">
                <transition name="shanchu">
                  <div class="mobile_delete delete_icon" v-show="showPasswordIcon " @click="passwordDelete"></div>
                </transition>
              </template>
            </el-input>
          </div>
        </el-form-item>
        <button :class="['next']" @click="submit" :style="passwordForm.newPassword && passwordForm.password ?'background: linear-gradient(270deg, #0046B9 0%, #2D6DD7 100%);':''">确认修改</button>
      </el-form>
    </div>
    <div v-if="step == 3" class="update_success">
      <img src="../../../../static/img/login/success.png" alt="">
      <div>密码修改成功</div>
      <button class="go_login" @click="goLogin">去登录</button>
    </div>
    <validationPT class="setVef" ref="vefCode" @VefCodeTrue="getVefCodeTrue" :inputPhone="form.mobile" theme="dialog"></validationPT>
  </div>
</template>
<script>
import { post, fetch } from "@/ask/axios";
import validationPT from '../../baseInfo/components/validationPT.vue'
export default {
  components: {
    validationPT,
  },
  data() {
    var codeSubmit = (rule, value, callback) => {
      if (!this.form.code) {
        this.isCodeError = true
        callback(new Error('请输入'))
      } else {
        this.isCodeError = false
        callback()
      }
    };

    var mobileSubmit = (rule, value, callback) => {
      if (!this.form.mobile) {
        this.isMobileError = true
        callback(new Error('请输入'))
      } else {
        this.isMobileError = false
        callback()
      }
    };
    var newPasswordSubmit = (rule, value, callback) => {
      if (!this.passwordForm.newPassword) {
        this.isNewPasswordError = true
        callback(new Error('请输入'))
      } else {
        this.isNewPasswordError = false
        callback()
      }
    };

    var passwordSubmit = (rule, value, callback) => {
      if (!this.passwordForm.password) {
        this.isPasswordError = true
        callback(new Error('请输入'))
      } else {
        this.isPasswordError = false
        callback()
      }
    };
    var newPswBlur = (rule, value, callback) => {
      if (this.passwordForm.newPassword) {
        let regs = /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/;
        if (this.passwordForm.newPassword.length >= 8 && this.passwordForm.newPassword.length <= 16 && regs.test(this.passwordForm.newPassword)) {
          this.errorMessage = false
          this.isNewPasswordError = false
          callback()
        } else {
          setTimeout(() => {
            this.errorMessage = true
            this.isNewPasswordError = true
            callback(new Error('密码长度为8-16,需包含数字、字母'))
          }, 100);

        }
      } else {
        this.isNewPasswordError = false
        callback()
      }
    };

    var mobileChange = (rule, value, callback) => {
      if (this.form.mobile) {
        let regs = /^1[3,4,5,6,7,8,9][0-9]{9}$/
        if (regs.test(this.form.mobile)) {
          let url =
            this.$api04 + "/BasicsSupplier/api/CustomerInfo/CKPhoneGetUserInfo";
          let param = {
            telphone: this.form.mobile
          };
          post(url, param).then((res) => {
            if (res.IsOK) {
              this.isMobileError = false
              this.mobileErrorMsg = ''
              callback()
            } else {
              setTimeout(() => {
                this.isMobileError = true
                this.mobileErrorMsg = '手机号未注册绑定'
                callback(new Error('手机号未注册绑定'))
              }, 100);
            }
          });
        } else {
          setTimeout(() => {
            this.isMobileError = true
            this.mobileErrorMsg = '手机号格式不正确'
            callback(new Error('手机号格式不正确'))
          }, 100);
        }
      } else {
        this.isMobileError = false
        this.mobileErrorMsg = ''
        callback()
      }
    };
    return {
      form: {
        mobile: "",
        code: "",
      },
      passwordForm: {
        newPassword: "",
        password: "",
      },
      showIcon: false, //是否显示删除图标
      showMobileIcon: false, //是否显示手机号删除图标
      showNewPasswordIcon: false,
      showPasswordIcon: false,
      isMobileFocus: false, //是否聚焦手机号输入框
      isCodeFocus: false, //是否聚焦验证码输入框
      isMobileError: false, //手机号是否错误
      isCodeError: false, //验证码是否错误
      mobileErrorMsg: "",//手机号错误信息
      codeErrorMsg: "",//验证码错误信息
      isNewPasswordFocus: false,
      isPasswordFocus: false,
      isNewPasswordError: false,
      isPasswordError: false,
      errorMessage: false,
      waitTime: -1,
      step: 1,
      passwordRules: {
        newPassword: [
          {
            required: true,
            trigger: "submit",
            validator: newPasswordSubmit,
          },
          {
            required: true,
            trigger: "blur",
            validator: newPswBlur,
          },
        ],
        password: [
          {
            required: true,
            trigger: "submit",
            validator: passwordSubmit,
          },
        ],
      },
      fogetRules: {
        mobile: [
          {
            required: true,
            trigger: "submit",
            validator: mobileSubmit,
          },
          {
            required: true,
            trigger: ["blur"],
            validator: mobileChange,
          },
        ],
        code: [
          {
            required: true,
            trigger: "submit",
            validator: codeSubmit,
          },
        ],
      },
    }
  },
  computed: {
    canClkNext() {
      let regs = /^1[3,4,5,6,7,8,9][0-9]{9}$/
      if (
        this.form.mobile.length == 11 && regs.test(this.form.mobile) && this.form.code && !this.isMobileError
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    // 点击下一步
    next() {
      let url = this.$apiIse + "/api/EbaySupplier/MobileCode/GetVerifyCodeForgetPsw";
      let params = {
        mobileValidateCode: this.form.code,
        mobile: this.form.mobile,
      };
      this.$refs.form.validate((valid) => {
        console.log(valid, "valid");
        if (valid) {
          fetch(url, params).then((res) => {
            if (res.Results) {
              this.isCodeError = false
              this.codeErrorMsg = ''
              this.step = 2
            } else {
              this.isCodeError = true
              this.codeErrorMsg = '验证码错误'
            }
          });
        } else {
        }
      });
    },
    // 确认修改
    submit() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          if (this.passwordForm.newPassword !== this.passwordForm.password) {
            this.isNewPasswordError = true
            this.isPasswordError = true
            this.$message.error('重复密码不一致')
            return
          } else {
            console.log(this.form.mobile, this.form.code, 'this.form.code');
            let url = this.$apiIse + "/api/EbaySupplier/Customer/ForgetPassword";
            let params = {
              Phone: this.form.mobile,
              PhoneCode: this.form.code,
              Password: this.passwordForm.password,
            };
            post(url, params).then((res) => {
              if (res.IsOK) {
                this.step = 3;
              } else {
                this.$message.error(res.Message);
              }
            });
          }
        }
      });
    },
    //去登录
    goLogin() {
      this.$emit('closeForgetDialog')
    },
    // 获取验证码
    gainCode() {
      let regs = /^1[3,4,5,6,7,8,9][0-9]{9}$/
      let regsRight = regs.test(this.form.mobile)
      console.log(regsRight);
      if (this.form.mobile.length !== 11 || this.mobileErrorMsg || this.isMobileError || this.waitTime >= 0 || !regsRight) {
        return
      }
      let url =
        this.$api04 + "/BasicsSupplier/api/CustomerInfo/CKPhoneGetUserInfo";
      let param = {
        telphone: this.form.mobile
      };
      post(url, param).then((res) => {
        if (res.IsOK) {
          this.$refs.vefCode.GetSlideBlockApi(); //获取图片
          this.$refs.vefCode.clkOpenRef(); //打开框
          this.$refs["codeInput"].focus();
        } else {
          return
        }
      });

    },
    // 拼图验证正确回调
    getVefCodeTrue({ MarkCode, LstMouseTrack }) {
      this.pTparams = {
        MarkCode: MarkCode,
        LstMouseTrack: LstMouseTrack,
        Mobile: this.form.mobile,
      };
      //供应商获取验证码
      let url = this.$apiIse + "/api/EbaySupplier/MobileCode/GenerateMobileCodeEditPsw";
      post(url, this.pTparams).then((res) => {
        if (!res.IsOK) {
          this.$message.error(Message);
        }
      });
      let timer = null;
      this.waitTime = 120
      if (!timer) {
        timer = setInterval(() => {
          if (this.waitTime > 0) {
            this.waitTime--;
          } else {
            clearInterval(timer);
            timer = null;
            this.waitTime = -1;
          }
        }, 1000);
      }
    },
    // 聚焦验证码输入框
    codeFocus() {
      this.isCodeFocus = true;
      this.isCodeError = false
      this.codeErrorMsg = ''
      if (this.form.code) {
        this.showIcon = true;
      } else {
        this.showIcon = false;
      }
    },
    // 失焦验证码输入框
    codeBlur() {
      setTimeout(() => {
        this.isCodeFocus = false;
        this.showIcon = false;
      }, 100);
    },
    // 移入验证码输入框
    codeMove() {
      if (this.form.code && !this.isCodeFocus) {
        this.showIcon = true;
      }
    },
    // 移出验证码输入框
    codeOut() {
      if (!this.isCodeFocus) {
        this.showIcon = false;
      }
    },
    // 监听验证码输入框
    codeInput() {
      this.showIcon = this.form.code.length > 0;
    },
    // 清楚验证码
    codeDelete() {
      this.form.code = "";
      this.isCodeError = false
      this.isCodeFocus = false
      this.showIcon = false;
    },
    // 聚焦手机号输入框
    mobileFocus() {
      this.isMobileFocus = true;
      this.isMobileError = false;
      this.mobileErrorMsg = ""
      if (this.form.mobile) {
        this.showMobileIcon = true;
      } else {
        this.showMobileIcon = false;
      }
    },
    // 失焦手机号输入框
    mobileBlur() {
      setTimeout(() => {
        this.isMobileFocus = false;
        this.showMobileIcon = false;
      }, 100);
    },
    // 移入手机号输入框
    mobileMove() {
      if (this.form.mobile && !this.isMobileFocus) {
        this.showMobileIcon = true;
      }
    },
    // 移出手机号输入框
    mobileOut() {
      if (!this.isMobileFocus) {
        this.showMobileIcon = false;
      }
    },
    // 监听手机号输入框
    mobileInput() {
      this.showMobileIcon = this.form.mobile.length > 0;
    },
    // 清楚手机号
    mobileDelete() {
      setTimeout(() => {
        this.form.mobile = "";
        this.isMobileError = false
        this.isMobileFocus = false
        this.showMobileIcon = false;
        this.mobileErrorMsg = ""
      }, 150);
    },
    // 聚焦新密码输入框
    newPasswordFocus() {
      this.isNewPasswordFocus = true;
      this.isNewPasswordError = false;
      this.errorMessage = false
      if (this.passwordForm.newPassword) {
        this.showNewPasswordIcon = true;
      } else {
        this.showNewPasswordIcon = false;
      }
    },
    // 失焦新密码输入框
    newPasswordBlur() {
      setTimeout(() => {
        this.isNewPasswordFocus = false;
        this.showNewPasswordIcon = false;
      }, 100);
    },
    // 移入新密码输入框
    newPasswordMove() {
      if (this.passwordForm.newPassword && !this.isNewPasswordFocus) {
        this.showNewPasswordIcon = true;
      }
    },
    // 移出新密码输入框
    newPasswordOut() {
      if (!this.isNewPasswordFocus) {
        this.showNewPasswordIcon = false;
      }
    },
    // 监听新密码输入框
    newPasswordInput() {
      this.showNewPasswordIcon = this.passwordForm.newPassword.length > 0;
    },
    // 清楚新密码
    newPasswordDelete() {
      setTimeout(() => {
        this.passwordForm.newPassword = "";
        this.isNewPasswordError = false
        this.isNewPasswordFocus = false
        this.showNewPasswordIcon = false;
        this.errorMessage = false
      }, 150);
    },
    // 聚焦再次输入密码输入框
    passwordFocus() {
      this.isPasswordFocus = true;
      this.isPasswordError = false;
      if (this.passwordForm.password) {
        this.showPasswordIcon = true;
      } else {
        this.showPasswordIcon = false;
      }
    },
    // 失焦再次输入密码输入框
    passwordBlur() {
      setTimeout(() => {
        this.isPasswordFocus = false;
        this.showPasswordIcon = false;
      }, 100);
    },
    // 移入再次输入密码输入框
    passwordMove() {
      if (this.passwordForm.password && !this.isPasswordFocus) {
        this.showPasswordIcon = true;
      }
    },
    // 移出再次输入密码输入框
    passwordOut() {
      if (!this.isPasswordFocus) {
        this.showPasswordIcon = false;
      }
    },
    // 监听再次输入密码输入框
    passwordInput() {
      this.showPasswordIcon = this.passwordForm.password.length > 0;
    },
    // 清楚再次输入密码
    passwordDelete() {
      setTimeout(() => {
        this.passwordForm.password = "";
        this.isPasswordError = false
        this.isPasswordFocus = false
        this.showPasswordIcon = false;
      }, 150);
    },
  },
}
</script>
<style lang="scss" scoped>
.mobile_code ::v-deep .el-form {
  .el-form-item {
    margin: 0;
  }
  .el-form-item__content {
    line-height: 40px;
  }
}
.mobile_code ::v-deep .el-input {
  .el-input__inner {
    height: 40px !important;
    background: #ffffff;
    box-shadow: 0px 0px 0px 2px rgba(0, 70, 185, 0);
    border-radius: 8px;
    border: 1px solid #dddddd !important;
    line-height: 40px !important;
    transition: border 0.2s;
    padding: 0 56px 0 40px !important;

    &:hover {
      border: 1px solid #aaaaaa !important;
      transition: border 0.2s;
    }
    &:focus {
      border: 1px solid #0046b9 !important;
      transition: border 0.2s;
    }
  }
  .el-input__suffix {
    right: 0;
  }
  .el-input__suffix-inner {
    display: flex;
    margin: 12px 0;
  }
}
.password_input ::v-deep .el-input {
  .el-input__inner {
    height: 40px !important;
    background: #ffffff;
    box-shadow: 0px 0px 0px 2px rgba(0, 70, 185, 0);
    border-radius: 8px;
    border: 1px solid #dddddd !important;
    line-height: 40px !important;
    transition: border 0.2s;
    padding: 0 56px 0 16px !important;
  }
}
.mobile_code ::v-deep .el-input .el-input__inner::placeholder {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #aaaaaa;
}
.mobile_input
  ::v-deep
  .el-input
  .el-input__inner:focus
  + .el-input__prefix
  .mobile_icon {
  background: url("../../../../static/img/login/ic_phone_active@2x.png")
    no-repeat;
  background-size: 24px 24px;
  background-position: center;
  transition: background 0.2s;
}
.code_input
  ::v-deep
  .el-input
  .el-input__inner:focus
  + .el-input__prefix
  .code_icon {
  background: url("../../../../static/img/login/ic_code_active@2x.png")
    no-repeat;
  background-size: 24px 24px;
  background-position: center;
  transition: background 0.2s;
}
// .mobile_code ::v-deep .el-input .el-input__inner:focus
.code_input {
  margin-top: 16px;
  display: flex;
}
.code_input ::v-deep .el-input {
  .el-input__inner {
    width: 176px;
  }
  .el-input__suffix {
    right: 16px;
  }
}
.mobile_icon {
  width: 36px;
  height: 40px;
  background: url("../../../../static/img/login/ic_phone_normal@2x.png")
    no-repeat;
  background-size: 24px 24px;
  background-position: center;
  transition: background 0.2s;
}
.code_icon {
  width: 36px;
  height: 40px;
  background: url("../../../../static/img/login/ic_code_normal@2x.png")
    no-repeat;
  background-size: 24px 24px;
  background-position: center;
  transition: background 0.2s;
}
.delete_icon {
  width: 16px;
  height: 16px;
  background: url("../../../../static/img/login/ic_login_delete_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  cursor: pointer;
  &:hover {
    background: url("../../../../static/img/login/ic_login_delete_hover@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
  &:active {
    background: url("../../../../static/img/login/ic_login_delete_click@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
}
.mobile_delete {
  margin-right: 16px;
}
.user_eye_hide {
  width: 16px;
  height: 16px;
  background: url("../../../../static/img/login/ic_login_show_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  margin: 0 16px 0 8px;
  cursor: pointer;
  &:hover {
    background: url("../../../../static/img/login/ic_login_show_hover@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
  &:active {
    background: url("../../../../static/img/login/ic_login_show_click@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
}
.user_eye_show {
  width: 16px;
  height: 16px;
  background: url("../../../../static/img/login/ic_login_hide_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  margin: 0 16px 0 8px;
  cursor: pointer;
  &:hover {
    background: url("../../../../static/img/login/ic_login_hide_hover@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
  &:active {
    background: url("../../../../static/img/login/ic_login_hide_click@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
}
.mobile_code .el-form .mobile_input_error ::v-deep .el-input__inner {
  box-shadow: 0px 0px 0px 2px rgba(216, 63, 63, 0.08) !important;
  border-radius: 8px;
  border: 1px solid #d83f3f !important;
  &::placeholder {
    color: #d83f3f;
  }
  &:hover {
    border: 1px solid #d83f3f !important;
    transition: border 0.2s;
  }
}
.mobile_code .mobile_input_error ::v-deep .el-input__prefix .mobile_icon {
  width: 36px;
  height: 40px;
  background: url("../../../../static/img/login/ic_phone_error@2x.png")
    no-repeat !important;
  background-size: 24px 24px !important;
  background-position: center !important;
  transition: background 0.2s;
}
.mobile_code .code_input_error ::v-deep .el-input__inner {
  box-shadow: 0px 0px 0px 2px rgba(216, 63, 63, 0.08) !important;
  border-radius: 8px;
  border: 1px solid #d83f3f !important;
  &:hover {
    border: 1px solid #d83f3f !important;
    transition: border 0.2s;
  }
  &::placeholder {
    color: #d83f3f;
  }
}
.mobile_code .code_input_error ::v-deep .el-input__prefix .code_icon {
  width: 36px;
  height: 40px;
  background: url("../../../../static/img/login/ic_code_error@2x.png") no-repeat;
  background-size: 24px 24px;
  background-position: center;
  transition: background 0.2s;
}
.gain_code {
  flex-shrink: 0;
  width: 96px;
  height: 40px;
  background: #a3bce5;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  border: none;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  transition: background 0.2s;
  padding: 0;
}
.next {
  width: 280px;
  height: 40px;
  background: linear-gradient(270deg, #a3bce5 0%, #b3caf0 100%);
  border-radius: 8px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-top: 24px;
  cursor: pointer;
  outline: none;
  border: none;
  transition: background 0.2s;
}
.can_next {
  background: linear-gradient(270deg, #0046b9 0%, #2d6dd7 100%);
  transition: background 0.2s;
}
.mobile_error_msg {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #d83f3f;
  position: absolute;
  top: 0;
  right: 8px;
}
.shanchu-enter,
.shanchu-leave-to {
  opacity: 0;
}
.shanchu-enter-to,
.shanchu-leave {
  opacity: 1;
}
.shanchu-enter-active,
.shanchu-leave-active {
  transition: all 0.2s;
}
.can_code {
  background: #0046b9;
  transition: background 0.2s;
  padding: 0;
}
.cant_code {
  background: #a3bce5;
  transition: background 0.2s;
}
.forget_password_dialog ::v-deep .framework {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -160px;
  margin-top: -115px;
  transform: translateX(0);
}
.code_error_msg {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #d83f3f;
  position: absolute;
  top: 15px;
  right: 114px;
}
.errorMessage {
  height: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #d83f3f;
  line-height: 20px;
  position: absolute;
  right: 8px;
  top: 10px;
}
.update_success {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    margin: 22px auto 16px;
  }
  div {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    margin-bottom: 30px;
  }
  button {
    width: 280px;
    height: 40px;
    background: linear-gradient(270deg, #0046b9 0%, #2d6dd7 100%);
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    outline: none;
    border: none;
    cursor: pointer;
  }
}
</style>